export { ThemeIcon } from './get-theme-icon';
export { MoreIcon } from './icons/moreIcon';
